import { render, staticRenderFns } from "./UserNavigation.vue?vue&type=template&id=4eb426ef&scoped=true&"
import script from "./UserNavigation.vue?vue&type=script&lang=js&"
export * from "./UserNavigation.vue?vue&type=script&lang=js&"
import style0 from "./UserNavigation.vue?vue&type=style&index=0&id=4eb426ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb426ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb426ef')) {
      api.createRecord('4eb426ef', component.options)
    } else {
      api.reload('4eb426ef', component.options)
    }
    module.hot.accept("./UserNavigation.vue?vue&type=template&id=4eb426ef&scoped=true&", function () {
      api.rerender('4eb426ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserNavigation.vue"
export default component.exports